// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './stores/index'
import auth from './api/auth'
import settings from './api/settings'
import payment from './api/payment'
import tickets from './api/tickets'
//import "./assets/css/blk-design-system.css"
import './assets/css/nucleo-icons.css'
import './assets/demo/demo.css'
import VueFormGenerator from 'vue-form-generator'
import ModuleLibrary from 'vfg-field-array'
import landing from './components/dashboard/landing.vue'
import ticket from './api/ticket'
import stats from './api/stats'
import user from './api/user'
import VueSweetalert2 from 'vue-sweetalert2'
import VuePageTransition from 'vue-page-transition'
import VueApexCharts from 'vue-apexcharts'
import Loading from 'vue-loading-overlay'
import Multiselect from 'vue-multiselect'
//loading styles
import 'vue-loading-overlay/dist/vue-loading.css'
import vueTopprogress from 'vue-top-progress'
import guild from './api/guild'

//import custom twemoji
import twemoji from './modules/twemoji'
Vue.use(twemoji)
Vue.use(vueTopprogress)

Vue.use(Loading)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(VueSweetalert2)
Vue.component('multiselect', Multiselect)
Vue.use(ModuleLibrary)
Vue.use(VueFormGenerator)
Vue.config.productionTip = false

Vue.use(payment)
Vue.use(auth)
Vue.use(user)
Vue.use(guild)
Vue.use(settings)
Vue.use(ticket)
Vue.use(tickets)
Vue.use(stats)
Vue.component('landing', landing)
Vue.use(VuePageTransition)

Vue.directive('click-outside', {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event)
            }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    store: store,
})



// WEBPACK FOOTER //
// ./src/main.js